import HomeLayout from "./home/layout";

export default function Home() {
  return (
    <div className="">
      <HomeLayout />
    </div >
  );
}
